module.exports = __webpack_public_path__ + "img/test.112bbf2f.png";